module.exports = __webpack_public_path__ + "static/media/logo.af3aaa59.svg";